<div class="tabs tabBlue">
  <span class="tablinks all_stories " (click)="snowplowAnalytics('Microsite');activeMenu = 'micrositeList'"
    [class]="activeMenu === 'micrositeList' ? 'active' : ' '" id="defaultOpen">Microsite</span>
  <span id='templateTab' *ngIf="isTemplatePermission()" class="tablinks my_workspace" (click)="snowplowAnalytics('Template');activeMenu = 'templateList'"
    [class]="activeMenu === 'templateList' ? 'active' : ' '" id="printFeedTab">Template</span>
</div>
<ng-container [ngSwitch]="activeMenu">
  <ng-container *ngSwitchCase="'micrositeList'">
    <div  class="pageContainer tabcontent rssFeed" id="allStories" style="display: block;">
      <app-microsite-listing #msListing pageId="micrositeList"></app-microsite-listing>
  </div>
  </ng-container>
  <ng-container *ngSwitchCase="'templateList'">
    <div class="pageContainer tabcontent templateList rssFeed customMicrosite" id="myWorkspace" style="display: block;">
      <app-microsite-listing #templateListing pageId="templateList"></app-microsite-listing>
  </div>
  </ng-container>
  <ng-container *ngIf="openCreateMicrositeFlag">
    <div class="lightBox sendNotifications" style="display:block;">
      <div class="notificationWindow">
        <div class="unlockStory">
          <div class="wid100 pad30">
            <div class="headerBlock" id="sendNotificationButton">
            <h3 class="flSendNoti">Create Microsite</h3>

          </div>
            <div class="salesReport">
              <div class="sendNotificationBlock">
              <div class="sendNotification">
  
                  <ul class="twoLi">
                      <li [class]="mandatoryFieldMessage ? 'errorInput' : ''">
                          <label for="title" class="control-label">Microsite Name *</label>
                          <input id="title" type="text" class="form-control"  maxlength="101" [(ngModel)]="microsite.title">
                          <div *ngIf="microsite.title && microsite.title.length > 100 " class="redImp">* 100 char limit exceded</div> 
                      </li>
                  </ul>
                  <ul class="twoLi" >
                      <li>
                        <label for="description" class="control-label">Description *</label>
                        <textarea id="description" name="description" size="30" class="form-control" [(ngModel)]="microsite.description"></textarea>
                      </li>
                  </ul>

                  <ul class="twoLi">
                    <li >
                      <label>Template *</label>
    
                      <div class="dataField">
                        <input type="text" class="textBox form-control" #templateInput 
                          placeholder="Choose Template..." [(ngModel)]="templateQuery" (keyup)="filterAutoCompleteUp($event ,'template')"
                          (keydown)="filterAutoCompleteDown($event ,'template')" (focus)="focusInSuggest('template')"
                          (focusout)="false">
                        <ng-container>
                          <div #templateList class="autosuggestion block borderFix" *ngIf="filteredTemplateSuggestion && filteredTemplateSuggestion.length > 0">
                            <ul *ngFor="let item of filteredTemplateSuggestion; let i = index">
                              <li (click)="selectAutoComplete('template', item)" [class.active]="i === currentSelection">
                                <span class="name">{{item.name}}</span>
                                <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                              </li>
                            </ul>
                          </div>
                          <ng-container *ngIf="insideTemplate && (1 > filteredTemplateSuggestion.length)">
                            <div class="autosuggestion block">
                              <ul>
                                <li>
                                  <span class="name">No Results</span>
                                </li>
    
                              </ul>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </li>
                  </ul>

                  <ul class="twoLi">
                    <li >
                      <label>Page URLs</label> <ng-container *ngIf="!selectedTemplate"><label> (Select Template Please..)</label></ng-container>
                      <ng-container *ngIf="selectedTemplate">
                        <ng-container *ngFor="let page of counter(selectedTemplate.pageCount);let i = index">
                            <!-- <li>
                                <label for="title" class="control-label">Page Label {{i+1}}</label>
                                <input id="title" type="text" class="form-control" [(ngModel)]="micrositePages[i]['label']">
                            </li> -->
                              <li>
                                <label for="description" class="control-label nospace">URL for {{i+1}}  *</label> 
                                <input id="title" type="text" class="form-control" [(ngModel)]="micrositePages[i]['url']" >
                                <div *ngIf="!checkUrlValidate(micrositePages[i]['url'])" class="redImp">* Please enter valid URL</div> 
                              </li>
                        </ng-container>
                      </ng-container>
                    </li>
                  </ul>
                  
                  <ul class="twoLi" >
                    <li>
                      <div class="">
                        <ng-container *ngIf="!microsite['logo']">
                          <label>Upload Logo *</label>
                          <div class="dataField">
                            <div class="stepsDropBlock">
                              <div class="imageInsert uploadnew">
                                <!-- <span>Upload from file</span> -->
                                <label for="upload" class="new">Upload from file</label>
                                <input id="upload"  type="file" hidden name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'logo')" />
                                
                              </div>
                              <div class="imageLibrary " (click)="addLogoGallery()">
                                <label class="new">Pick from Library</label>
                              </div>
                              </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="microsite['logo']">
                          <label>Logo *</label>
                          <div class="dataField">
                            <div class="stepsDropBlock imageNameView">
                          {{microsite['logo']}}

                          <button (click)="removeMicroImage('logo')" class="blueRemove">Remove Image</button>
                        </div>
                        </div>
                        </ng-container>
                      </div>
                    </li>
                  </ul>
                  <ul class="twoLi" >
                    <li>
                      <div class="">
                        <ng-container *ngIf="!microsite['banner']">
                          <label>Upload Banner *</label>
                          <div class="dataField">
                            <div class="stepsDropBlock">
                              <div class="imageInsert uploadnew">
                                <!-- <span>Upload from file</span> -->
                                <label for="uploadfile" class="new">Upload from file</label>
                                <input id="uploadfile" type="file" hidden name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'banner')" />
                               
                              </div>
                              <div class="imageLibrary " (click)="addBannerGallery()">
                                <label class="new">Pick from Library</label>
                              </div>
                              </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="microsite['banner']">
                          <label>Banner Image</label>
                          <div class="dataField">
                            <div class="stepsDropBlock imageNameView">
                              {{microsite['banner']}}

                          <button (click)="removeMicroImage('banner')" class="blueRemove">Remove Image</button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </li>
                  </ul>
  
              </div>
          </div>
            </div>
          </div>
          <div class="fr wid100 right padlr30 ptb15">
            <button class="cancel gray ml10" name="cancel"
              (click)="closeMicrosite()" type="button">Cancel</button>
            <button class="add blue ml10 " name="send" type="button" (click)="saveMicrosite()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="openCreateTemplateFlag">
    <div class="lightBox sendNotifications" style="display:block;">
      <div class="notificationWindow">
        <div class="unlockStory">
          <div class="wid100 pad30">
            <div class="headerBlock" id="sendNotificationButton">
            <h3 class="flSendNoti">Create Template</h3>

          </div>
            <div class="salesReport">
              <div class="sendNotificationBlock">
              <div class="sendNotification">
  
                  <ul class="twoLi">
                      <li [class]="mandatoryFieldMessage ? 'errorInput' : ''">
                          <label for="title" class="control-label">Template Name</label>
                          <input id="title" type="text" class="form-control"  maxlength="101" [(ngModel)]="template.name">
                          <div *ngIf="template.name && template.name.length > 100 " class="redImp">* 100 char limit exceded</div> 
                      </li>
                  </ul>
                  <ul class="twoLi" >
                      <li>
                        <label for="count" class="control-label">Page Count</label>
                        <input id="count" name="count" type="number" min="0" max="99" class="form-control" [(ngModel)]="template.pageCount">
                      </li>
                  </ul>
                  
                    <ng-container *ngIf="!template.pageCount">
                      <label for="count" class="control-label">Page Content Template (* Enter page count to select Templates) </label>
                    </ng-container>
                    <ng-container *ngIf="template.pageCount">
                      <ng-container *ngFor="let item of [].constructor(template.pageCount) ; let i = index">
                        <ul class="twoLi" >
                          <li>
                            <label for="count" class="control-label">Page {{i+1}} Content Template</label>
                            <div class="dataField">
                              <tags-creator [autoSuggest]="true" [autocompletelist]="elementList" (focusoutfn)="disableInnerFocus($event)" [noMinReq]="true"
                                [data]="template.list" [setFocus]="innerFocusFlag"
                                [displayText]="'Choose Page elements here..'" (clickfn)="customFunc($event)" (changefn)="template.pageContentTemplate[i] = $event"
                                (focusedfn)="catchTagFocus($event)"></tags-creator>
                            </div>
                          </li>
                        </ul>
                      </ng-container>
                    </ng-container>
                    
  
              </div>
          </div>
            </div>
          </div>
          <div class="fr wid100 right padlr30 ptb15">
            <button class="cancel gray ml10" name="cancel"
              (click)="closeMicrosite()" type="button">Cancel</button>
            <button class="add blue ml10 " name="send" type="button" (click)="saveTemplate()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  
</ng-container>

<div [class]="logoGalleryFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="logoGalleryFlag = false;"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addLogo($event, 'logo')" *ngIf="logoGalleryFlag"></div>
</div>

<div [class]="bannerGalleryFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="bannerGalleryFlag = false;"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addLogo($event, 'banner')" *ngIf="bannerGalleryFlag"></div>
</div>

<div class="image-cropper" *ngIf="showLogoCropper" [cropperImageUrl]="cropperImageUrl" 
  (finish)="finishCropping($event, 'logo')" (cancel)="cancelCropping($event)" [isImageLead]="false" [verticalImageFlag]="false" [isMicrositeImage]="true" 
  ></div>

  <div class="image-cropper" *ngIf="showBannerCropper" [cropperImageUrl]="cropperImageUrl" 
  (finish)="finishCropping($event, 'banner')" (cancel)="cancelCropping($event)" [isImageLead]="false" [verticalImageFlag]="false" [liveblogCropper]="true" 
  ></div>
